import { useRoutes } from "react-router-dom";
import { Box } from "@mui/material";
import rootRoute from "./routes/private/root/index";
import authRoute from "./routes/public";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import resetPasswordRoute from "./routes/private/resetPassword"

const App = () => {
  const element = useRoutes([
    rootRoute,
    ...authRoute,
    ...resetPasswordRoute,
  ]);

  return (
    <Box>
       <LocalizationProvider dateAdapter={AdapterDayjs}>
          {element}
       </LocalizationProvider>
    </Box>
  );
};

export default App;